import {
  Box,
  Container,
  Dialog,
  IconButton,
  Slide,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { CloseSmall } from "assets/Icon";
import { forwardRef, useState } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function Modal({
  onClose,
  open,
  title,
  hideContainer,
  maxWidth = "lg",
  children,
  dir = "ltr",
  closeIcon = true,
  persistent
}) {
  const theme = useTheme();
  const [showPersistAnimation, setSowPersistAnimation] = useState(false)

  const handleAnimateModal = () => {
    setSowPersistAnimation(true)

    setTimeout(() => {
      setSowPersistAnimation(false)
    }, 200)
  }

  const handleCloseOnClickOut = () => {
    if (persistent) {
      return handleAnimateModal()
    }

    onClose()
  }

  return (
    <DialogStyle
      open={open}
      TransitionComponent={Transition}
      keepMounted
      maxWidth={maxWidth}
      onClose={handleCloseOnClickOut}
      aria-describedby="alert-dialog-slide-description"
      showPersistAnimation={showPersistAnimation}
    >
      {hideContainer ? (
        <>{title}</>
      ) : (
        <DialogTitleWrapper dir={dir || "rtl"}>
          <Typography variant="h6" color="common.white">
            {title}
          </Typography>
          {closeIcon && (
            <IconButton onClick={onClose} color="text.main">
              <CloseSmall color={theme.palette.common.white} />
            </IconButton>
          )}
        </DialogTitleWrapper>
      )}
      {hideContainer ? (
        <>{children}</>
      ) : (
        <DialogContainer>{children}</DialogContainer>
      )}
    </DialogStyle>
  );
}

const DialogStyle = styled(Dialog)(({ showPersistAnimation }) => ({
  ".MuiDialog-container > .MuiPaper-root": {
    width: "100%",
    borderRadius: "8px",
    animation: showPersistAnimation ? 'puls 0.2s alternate infinite' : 'none'
  },

  "@keyframes puls": {
    "0%": {
      transform: "scale(1.05)",
    },
    "50%": {
      transform: "scale(1.1)",
    },
    "100%": {
      transform: "scale(1.0)",
    },
  },
}));

const DialogContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const DialogTitleWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: theme.palette.background.headerModal,
  position: "sticky",
  top: "0",
  zIndex: 1,
  "&:before": {
    content: "''",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    background: theme.palette.background.primaryGradient,
    height: "100%",
    zIndex: "-1",
  },
}));

export default Modal;
